export default "__VITE_ASSET__IO2$WK3k__"